module.exports = __webpack_public_path__ + "static/media/work.original.2ce3cd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/img/work.original.png
// module id = 1604
// module chunks = 0